import { render, staticRenderFns } from "./Medal.vue?vue&type=template&id=ba6ecace&"
import script from "./Medal.vue?vue&type=script&lang=js&"
export * from "./Medal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports